module.exports = __webpack_public_path__ + "img/updated_cyberblade.594ee980.gif";